var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{'ui-text-underline-btn': true, active: _vm.active },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }